<template>
  <div class="w-full">
    <div class="flex justify-end relative mb-6">
      <!-- <el-form>
        <el-form-item>
          <el-input class="w-full" v-model="search" placeholder="Search">
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </el-form-item>
      </el-form> -->
      <div>
        <el-button
          @click="goToCreateYieldForm"
          class="bg-primary py-2 font-light border-none rounded-lg text-white text-sm"
          >Create Yield Profile</el-button
        >
      </div>
    </div>
    <div v-if="isLoading">
      <spinner
        size="medium"
        :spacing="40"
        message=""
        :line-fg-color="$primaryColor"
      />
    </div>
    <div v-else>
      <el-table
        class="relative cursor-pointer -mt-6 font-normal"
        :class="{ minHeight: noData }"
        index
        :data="tableData"
        style="width: 100%"
      >
        <el-table-column class="w-full" width="auto">
          <template slot-scope="scope">
            <div class="flex items-center gap-x-4">
              <span>
                <arrow-up-graph-icon />
              </span>
              <span class="flex flex-col">
                <span class="mb-1 uppercase font-bold">{{
                  maskID(scope.row.yield_offering_id)
                }}</span>
                <span class="text-xs font-normal text-gray-40">Yield ID</span>
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="auto">
          <template slot-scope="scope">
            <div class="mb-1 capitalize" style="word-break: break-all">
              {{ scope.row.name }}
            </div>
            <div class="text-xs font-normal text-gray-40">Profile Name</div>
          </template>
        </el-table-column>
        <el-table-column width="auto">
          <template slot-scope="scope">
            <div>{{ scope.row.apyRate || 0 }}%</div>
            <div class="text-xs font-normal text-gray-40">APY</div>
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template slot-scope="scope">
            <el-dropdown class="cursor-pointer">
              <span class="flex item-center text-white">
                <more-icon />
              </span>
              <el-dropdown-menu class="rounded-xl" slot="dropdown">
                <el-dropdown-item>
                  <div class="" @click="goToYieldProfileDetails(scope.row)">
                    View
                  </div>
                </el-dropdown-item>
                <el-dropdown-item>
                  <div @click="editYieldProfileForm(scope.row)">Edit</div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="p-6 grid grid-cols-1 md:justify-items-end">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="page.size"
        @next-click="next"
        @prev-click="previous"
        background
        layout="prev, pager, next"
        :total="page.totalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { MaskID, GetCurrencyCountry } from '@/utils/helpers'
export default {
  name: 'YieldOfferingTable',
  components: {
    ArrowUpGraphIcon: () => import('@/assets/icons/ArrowUpGraphIcon.vue'),
    MoreIcon: () => import('@/assets/icons/MoreIcon.vue')
  },
  props: {
    tableData: Array
  },
  data () {
    return {
      search: '',
      isLoading: false,
      yieldOfferingId: '',
      payload: {
        page: 1,
        size: 10,
        status: '',
        type: '',
        from: '',
        to: ''
      }
    }
  },
  methods: {
    handleCurrentChange (val) {
      this.payload.page = val
      this.getYieldOfferingProfilesInformation()
    },
    maskID (val) {
      return MaskID(val)
    },
    getCurrencyCountry (val) {
      return GetCurrencyCountry(val)
    },
    goToCreateYieldForm () {
      this.$store
        .dispatch('externalApi/setEditYieldProfile', null)
        .then(() => this.$emit('goToCreateYieldForm'))
    },
    editYieldProfileForm (row) {
      this.$store
        .dispatch('externalApi/setEditYieldProfile', row)
        .then(() => this.$emit('goToCreateYieldForm'))
    },
    goToYieldProfileDetails (row) {
      this.$store.dispatch('externalApi/setEditYieldProfile', row)
      this.$router.push(`/api-management/yield/${row.yield_offering_id}`)
    },
    next () {
      this.payload.page++
      this.getYieldOfferingProfilesInformation()
    },
    previous () {
      this.payload.page--
      this.getYieldOfferingProfilesInformation()
    },
    getYieldOfferingProfilesInformation () {
      this.isLoading = true
      const vm = this
      this.$store
        .dispatch(
          'externalApi/getYieldOfferingProfilesInformation',
          this.payload
        )
        .then(() => {
          this.isLoading = false
        })
        .catch((error) => {
          const err = error.response
            ? error.response.data.error.publicMessage
            : error
          vm.$message({
            showClose: true,
            message: this.httpErrorMessage,
            type: 'error'
          })
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  computed: {
    page () {
      return this.$store.state.externalApi.yieldOfferingProfilesInformation.page
    },
    noData () {
      return this.tableData.length === 0
    }
  }
}
</script>
<style scoped>
>>> .el-table th {
  background: var(--background);
  border: none;
}
>>> .el-table tr {
  background: var(--background);
  border: none;
}
>>> .el-table th.el-table__cell > .cell {
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
  padding: 0.8rem 0rem;
}
>>> .el-pagination.is-background .btn-next.disabled,
.el-pagination.is-background .btn-next:disabled,
.el-pagination.is-background .btn-prev.disabled,
.el-pagination.is-background .btn-prev:disabled,
.el-pagination.is-background .el-pager li.disabled {
  background: green !important;
}
>>> .el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: var(--background-2) !important;
}
>>> li.number.active {
  background-color: var(--background) !important;
  border: 0.5px solid var(--color-primary) !important;
  box-sizing: border-box;
  border-radius: 100px;
  font-weight: 400;
  color: var(--color-primary) !important ;
}
>>> li.number {
  background-color: var(--background) !important;
  border: 0.5px solid var(--text-1) !important;
  box-sizing: border-box;
  border-radius: 100px !important;
  font-weight: 400;
  /* color: var(--color-primary) !important ; */
}
.minHeight {
  height: 30vh;
}
</style>
